import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import AuthenticatedLayout from "../layouts/AuthenticatedLayout";
import BlankLayout from "../layouts/BlankLayout";
import Login from "../pages/Authentication/Login";
import Dashboard from "../pages/Dashboard";
import ReportPage from "../pages/Reports/ReportPage";
import ReportResultPage from "../pages/Reports/ReportResultPage";
import VaultAccess from "../pages/LiveInventory/LiveInventory";
import Jewellery from "../pages/StyleInventory/StyleInventory";
import MyCart from "../pages/LiveInventory/MyCart";
import EnquiryPage from "../pages/Enquiry/Enquiry";
import EnquiryDetail from "../pages/Enquiry/EnquiryDetail";
import Wishlist from "../pages/Wishlist/Wishlist";
import StyleJewelleryDetail from "../pages/StyleInventory/StyleInventoryDetail";
import StyleCart from "../pages/StyleInventory/StyleCart";
import Checkout from "../pages/StyleInventory/Checkout";
import OrderList from "../pages/StyleInventory/OrderList";
import VaultAccessDetail from "../pages/LiveInventory/LiveInventoryDetail";
import Error404 from "../pages/Common/Error404";
import ProtectedRoute from "./ProtectedRoute";

import PageTransition from "../components/Common/PageTransition";

export default function AppRoutes() {
    return (
        <Routes>

            {/* ROOT */}
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* BEFORE LOGIN */}
            <Route element={<AuthLayout />}>
                <Route
                    path="/login"
                    element={
                        <PageTransition>
                            <Login />
                        </PageTransition>
                    }
                />
            </Route>

            {/* AFTER LOGIN */}
            <Route element={<ProtectedRoute />}>
                <Route element={<AuthenticatedLayout />}>

                    <Route
                        path="/dashboard"
                        element={
                            <PageTransition>
                                <Dashboard />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/report"
                        element={
                            <PageTransition>
                                <ReportPage />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/report-result"
                        element={
                            <PageTransition>
                                <ReportResultPage />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/cart"
                        element={
                            <PageTransition>
                                <MyCart />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/enquiry"
                        element={
                            <PageTransition>
                                <EnquiryPage />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/LiveInventory"
                        element={
                            <PageTransition>
                                <VaultAccess />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/StyleInventory"
                        element={
                            <PageTransition>
                                <Jewellery />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/product-detail/:style_ID"
                        element={
                            <PageTransition>
                                <VaultAccessDetail />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/enquiry-detail/:ENQUIRY_ID"
                        element={
                            <PageTransition>
                                <EnquiryDetail />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/detail"
                        element={
                            <PageTransition>
                                <StyleJewelleryDetail />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/Wishlist"
                        element={
                            <PageTransition>
                                <Wishlist />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/StyleCart"
                        element={
                            <PageTransition>
                                <StyleCart />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/Checkout"
                        element={
                            <PageTransition>
                                <Checkout />
                            </PageTransition>
                        }
                    />

                    <Route
                        path="/order"
                        element={
                            <PageTransition>
                                <OrderList />
                            </PageTransition>
                        }
                    />

                </Route>
            </Route>

            {/* FALLBACK */}
            <Route element={<BlankLayout />}>
                <Route
                    path="*"
                    element={
                        <PageTransition>
                            <Error404 />
                        </PageTransition>
                    }
                />
            </Route>

        </Routes>
    );
}